import { Box, Fade, Paper, Table, TableBody, TableContainer, TableRow } from '@mui/material';
import React, { memo, useMemo, useState } from 'react';
import { ICarrito } from '@/redux/models';
import { Order, getComparator, stableSort } from '@/utils/tableUtils';
import { useTablaCarpetaContext } from '../../logics/TablaCarritoProvider';
import LoadingRows from '../LoadingRows';
import '../TablaStyles.css';
import TableCarpetaPagination from './TableCarpetaPagination';
import { TableCarpetasHead } from './TableCarpetasHead';
import TableCarpetasToolbar from './TableCarpetasToolbar';
import TableRows from '../TableRows';

const NoRows = memo(() => (
  <TableRow sx={{ display: 'flex', justifyContent: 'center' }}>
    <Box sx={{ width: '100%', textAlign: 'center', p: 2 }}>
      No se encontraron carpetas
    </Box>
  </TableRow>
));

export default function TableCarp() {
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<keyof ICarrito>('idCarrito');

  const { context } = useTablaCarpetaContext();
  const { page, perPage, loading } = context;

  const visibleRows = React.useMemo(
    () => stableSort(context.carpetas as any, getComparator(order, orderBy)),
    [order, orderBy, page, perPage, loading, context.borrarCarpeta, context.modificarCarpeta, context.informes]
  );


  return (
    <Box sx={{ width: '100%' }} id="tablaCarpetas">
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableCarpetasToolbar />
        {loading ? <LoadingRows /> : context.carpetas.length === 0 ? <NoRows /> :
          (
            <Fade in={!loading} timeout={500}>
              <Box>
                <TableContainer className="tablaCarpetasContainer">
                  <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size='medium'>
                    <TableCarpetasHead
                      viewAs={context.viewAs}
                      order={order}
                      orderBy={orderBy}
                      setOrder={setOrder}
                      setOrderBy={setOrderBy}
                    />
                    <TableBody>
                      <TableRows visibleRows={visibleRows} />
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Fade>
          )}
        <TableCarpetaPagination />
      </Paper>
    </Box>
  );
}
